import React from 'react';
import { CrudStyles } from '../shared/Crud';

const { FormGroup, Input, Select, Button } = CrudStyles;

const rowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'flex-end',
    width: '100%',
};

const fieldStyle = { flex: '1 1 160px', minWidth: 0 };

const DEFAULT_ACTIVE = 'true';

/**
 * Filtros reutilizáveis para listagem de centros de custo (nome, código, ativo/inativo).
 */
export default function CostCenterSearchFilters({
    idPrefix = 'cost-center',
    nameValue,
    codeValue,
    activeFilter,
    onNameChange,
    onCodeChange,
    onActiveFilterChange,
    onClearFilters,
}) {
    const hasFilters = Boolean(
        (nameValue && String(nameValue).trim()) ||
            (codeValue && String(codeValue).trim()) ||
            activeFilter !== DEFAULT_ACTIVE,
    );
    return (
        <div style={rowStyle}>
            <FormGroup style={fieldStyle}>
                <label htmlFor={`${idPrefix}-name`}>Nome</label>
                <Input
                    id={`${idPrefix}-name`}
                    type="text"
                    value={nameValue}
                    onChange={(e) => onNameChange(e.target.value)}
                    placeholder="Filtrar por nome"
                    autoComplete="off"
                />
            </FormGroup>
            <FormGroup style={fieldStyle}>
                <label htmlFor={`${idPrefix}-code`}>Código</label>
                <Input
                    id={`${idPrefix}-code`}
                    type="text"
                    value={codeValue}
                    onChange={(e) => onCodeChange(e.target.value)}
                    placeholder="Filtrar por código"
                    autoComplete="off"
                />
            </FormGroup>
            <FormGroup style={{ ...fieldStyle, flex: '0 1 200px' }}>
                <label htmlFor={`${idPrefix}-active`}>Status</label>
                <Select
                    id={`${idPrefix}-active`}
                    value={activeFilter}
                    onChange={(e) => onActiveFilterChange(e.target.value)}
                >
                    <option value="true">Ativos</option>
                    <option value="false">Inativos</option>
                </Select>
            </FormGroup>
            <Button
                type="button"
                variant="outline"
                onClick={onClearFilters}
                disabled={!hasFilters}
                title={hasFilters ? 'Limpar filtros aplicados' : 'Nenhum filtro aplicado'}
            >
                Limpar
            </Button>
        </div>
    );
}
